
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/plugin-highlightcode.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-plugin-highlightcode-demo-basic","docs-x-markdown-plugin-highlightcode-demo-_semantic"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/plugin-highlightcode.en-US.md?type=demo')
};